import React from 'react';
import PropTypes from 'prop-types';
import { Button as AntButton } from 'antd';
import './styles/BtnSecondary.scss';

const BUTTON_SIZES = ['small', 'large', 'medium']

const Button = (props) => {
  const { additionalClassNames, children, loading, disabled, htmlType, _props, size,textPosition, onClick, ...overrides } = props;

  const className = `btn-secondary btn--${size} ${additionalClassNames} btn--${textPosition}`
  return (
    <div className='btn-secondary-container'>
      <AntButton htmlType={htmlType} type='default' disabled={disabled} loading={loading} className={className} onClick={onClick} {..._props} {...overrides}>
        {children}
      </AntButton>
    </div>
  );
};

Button.propTypes = {
  htmlType: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  _props: PropTypes.object,
  styleType: PropTypes.string,
  additionalClassNames: PropTypes.string,
  size: PropTypes.oneOf(BUTTON_SIZES),
  onClick: PropTypes.func
};

Button.defaultProps = {
  htmlType: 'button',
  disabled: false,
  type: 'primary',
  _props: {},
  styleType: 'primary',
  additionalClassNames: '',
  size: 'large',
  textPosition:'textCenter',
  onClick: () => { }
}

export default Button;